<template>
  <div class="produits-container">
    
    <div class="produits">
      
      <h1 class="produits-title">Réactifs Produits</h1>
    
      <!-- Breadcrumb -->
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/produits">Produits</a> > <a href="/reactifs">Réactifs Produits</a>
      </div>

      <!-- Tableau des réactifs -->
      <h2>TEST RAPIDE FORTRESS</h2>
      <table class="reactifs-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="reactif in reactifs" :key="reactif.code">
            <td>{{ reactif.code }}</td>
            <td>{{ reactif.article }}</td>
            <td>{{ reactif.cdt }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Tableau des cartes gel -->
      <h2>Cartes Gel ODAK</h2>
      <table class="cartes-gel-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carte in cartesGel" :key="carte.code">
            <td>{{ carte.code }}</td>
            <td>{{ carte.article }}</td>
            <td>{{ carte.cdt }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Tableau des réactifs d'hémostase-->
      <h2>Réactif de l'hémostase et l'identification des streptocoques</h2>
      <table class="hemostase-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="hemostase in hemostases" :key="hemostase.code">
            <td>{{ hemostase.code }}</td>
            <td>{{ hemostase.article }}</td>
            <td>{{ hemostase.cdt }}</td>
          </tr>
        </tbody>
      </table> 
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReactifsI',
  data() {
    return {
      reactifs: [
        { code: 'HBSCWB40', article: 'AG HBS', cdt: '40 TESTS' },
        { code: 'HCVC0040', article: 'HCV', cdt: '40 TESTS' },
        { code: 'HIV00040', article: 'HIV', cdt: '40 TESTS' },
        { code: 'HCGCSU40', article: 'BETA HCG', cdt: '40 TESTS' },
        { code: 'HAVIGM40', article: 'HAV IGM', cdt: '40 TESTS' },
        { code: 'RPC0020', article: 'CHLAMYDIA AG', cdt: '20 TESTS' },
        { code: 'FOBC0020', article: 'FOB-OCCULT BLOOD', cdt: '20 TESTS' },
        { code: 'TPC0020', article: 'SYPHILIS', cdt: '20 TESTS' },
        { code: 'URS00100', article: 'BANDELETTE URINE 11 P', cdt: '10 TESTS' },
        { code: 'DOAC0006', article: 'MULTI DRUG 6 P', cdt: '20 TESTS' },
        { code: 'DOAC0012', article: 'MULTI DRUG 12 P DEVICE URINE', cdt: '20 TESTS' },
        { code: 'HPYFC020', article: 'H PYLORI AG', cdt: '20 TESTS' },
        { code: 'HPYC020', article: 'H PYLORI AC', cdt: '20 TESTS' },
        { code: 'HPYCF040', article: 'H PYLORI AC', cdt: '40 TESTS' },
        { code: 'HPYC0040', article: 'H PYLORI AC', cdt: '40 TESTS' }
      ],
      cartesGel: [
        { code: 'OBGFRG-25', article: 'ADULTE OBG FORWARD AND REVERSE', cdt: '25 CARDS' },
        { code: 'OBGNEOG-25', article: 'OBG NEONATAL GROUPING', cdt: '25 CARDS' },
        { code: 'OBGAHG-25', article: 'OBG AHG GEL', cdt: '25 CARDS' },
        { code: 'OBGRBCAS3-CELL', article: 'OBG CELL SCREEN 1-2-3', cdt: '1-2-3 3*5ML' }
      ],
      hemostases: [
        { code: 'CS1087315', article: 'strepto grouping test 6x50 DETECTION', cdt: 'test 6x50' },
        { code: 'K29005558', article: 'SCLAVO APTT-S KIT 10X5ML', cdt: 'KIT 10X5ML' },
        { code: 'K29005005', article: 'SCLAVO PT-READYQUICK KIT 10X5ML', cdt: 'KIT 10X5ML' },
        { code: 'K29053762', article: 'FIBRONOGEN (LYOPHILIZED) 10X2 ML', cdt: '10X2 ML' }
      ]
    };
  }
};
</script>

<style scoped>
.produits-title {
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/reactif.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77); /* Texte blanc pour un meilleur contraste */
  padding: 200px 300px;
  font-size: 40px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px; /* Bordures légèrement arrondies */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Ombre subtile pour donner de la profondeur */
  max-width: 1000px;
}

.produits-container {
  padding: 85px 0px;
  background-color: #f9f9f9; /* Couleur de fond claire pour l'ensemble de la section */
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Police professionnelle */
}

.produits {
  max-width: 1200px;
  margin: 0 auto;
  padding: 5px;
  font-size: 16px;
  color: #333; /* Couleur du texte améliorée pour la lisibilité */
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Ombre subtile autour du contenu */
  border-radius: 10px;
}

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 10px;
}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease; /* Effet de transition */
}

.breadcrumb a:hover {
  color: #0056b3; /* Couleur au survol */
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Ombre autour des tableaux */
}

th, td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f5f5f5;
  color: #444;
  font-weight: bold;
  text-transform: uppercase; /* Majuscules pour les en-têtes */
}

td {
  color: #555;
}

th, td {
  border-right: 1px solid #ddd;
}

th:last-child, td:last-child {
  border-right: none;
}

h2 {
  color: #05305b; /* Utilisation d'une couleur professionnelle pour les titres */
  font-size: 24px;
  margin-top: 40px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
  text-align: center;
}

</style>
